<div [formGroup]="formGroup">
    <div [formGroupName]="controlName">
        <p-calendar
            inputStyleClass="text-sm height-40"
            styleClass="w-full"
            [dateFormat]="dateFormat"
            selectionMode="range"
            appendTo="body"
            [hideOnDateTimeSelect]="true"
            [readonlyInput]="true"
            #calendar
            placeholder="{{ label || dateFormat }}"
            panelStyleClass="shadow-md"
            [iconDisplay]="'input'"
            (ngModelChange)="onDateRangeChange($event)"
            [(ngModel)]="dateRange"
            [formControlName]="'value'"
            (ngModelChange)="onDateRangeChange($event)"
            (onClearClick)="$event.stopPropagation()"
            (onClickOutside)="onClickOutSide(calendar)"
            [showIcon]="true"
            inputId="templatedisplay"
        >
            <ng-template pTemplate="footer">
                <div class="flex justify-content-between border-top-2 border-primary-500 py-1">
                    <p-button
                        label="{{ 'default-cm-clear' | translate: 'Clear' }}"
                        styleClass="border-none"
                        [outlined]="true"
                        (onClick)="onClear(calendar)"
                    />
                    <p-button
                        label="{{ 'default-cm-today' | translate: 'Today' }}"
                        styleClass="border-none"
                        [outlined]="true"
                        (onClick)="onToday(calendar, $event)"
                    />
                </div>
            </ng-template>
            <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                <i (click)="clickCallBack($event)" class="cursor-pointer -translate-y-100 mt-3">
                    <img src="/assets/icons/calendar.svg" alt="" />
                </i>
            </ng-template>
        </p-calendar>
    </div>
</div>
